import { ThemeProvider, createGlobalStyle } from 'styled-components';

import { IPalette, useThemeHelper } from 'hooks/useTheme';

// The resolved "design elements" pair as CSS vars, so SCSS and portalled modals share the
// palette's fallback chain instead of the raw API value.
const UiColorVariables = createGlobalStyle<{ palette: IPalette }>`
  :root {
    --ui-background: ${({ palette }) => palette.uiBackground};
    --ui-text: ${({ palette }) => palette.uiText};
  }
`;

export const DesignThemeProvider: React.FC = ({ children }) => {
  const [theme] = useThemeHelper();

  return (
    <ThemeProvider theme={theme}>
      <UiColorVariables palette={theme.palette} />
      {children}
    </ThemeProvider>
  );
};
